import { render, staticRenderFns } from "./CouponMaster.vue?vue&type=template&id=070a846b&scoped=true"
import script from "./CouponMaster.vue?vue&type=script&lang=js"
export * from "./CouponMaster.vue?vue&type=script&lang=js"
import style0 from "./CouponMaster.vue?vue&type=style&index=0&id=070a846b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a846b",
  null
  
)

export default component.exports